import React, {useState} from 'react';
//import logo from "../../../assets/images_custom/img_logo_clicspy_login.png";
import logo from "../../../assets/images_custom/logo-form-extension.png";
import InputComponent from "../../../components/InputComponent";
import {validateEmail} from '../../../services/ValidationSvc'
import RequestSvc from '../../../services/RequestSvc';
import {URL_FORGOT} from '../../../utils/Constants';

/**
 * @author Hags
 * Formulario para hacer login en la plataforma
 * @returns {Element}
 * @constructor
 */
export default function ForgotForm() {

    let [email, setEmail] = useState("");
    let [hasCompleted, setHasCompleted] = useState(false);
    let [message, setMessage] = useState("");
    let [errorForgot, setErrorForgot] = useState(false);
    let [errorMessage, setErrorMessage] = useState(false);
    const origen = "pulpo"; // value required by backend

    /*  INIT - EVENTS */


    const submit = (event) => {
        let isValidForm = validateBeforeSubmit();
        if (isValidForm) {
            const payload = {
                email: email,
                origen: origen
            };
            tryForgot(payload)
        }
    }

    /**
     * Validar si el formulario es valido o no.
     * @returns {boolean}
     */
    const validateBeforeSubmit = () => {
        return !(email === "");
    }

    /**
     * Hacer el submit para reestablecer contraseña
     * @returns {Promise<void>}
     */
    const tryForgot = async (payload) => {
        let svc = new RequestSvc();
        let result = await svc.post(URL_FORGOT, payload);
        setHasCompleted(true)
        setMessage(result.data.data)
        if (result.code !== 200) {
            setErrorForgot(true)
            setErrorMessage(result.message)
        }
    }

    return (<div className={"forgot-form-layout"}>
        <img src={logo} alt={"imgBackground"} className={"login-container-img-logo"}/>
        <p className={"login-form-welcome-text"}> ¿Olvidaste la contraseña?</p>
        <p className={"login-secondary-text"} style={{marginBottom: 24}}>Escribe tu Email para continuar</p>
        <InputComponent
            placeholder={"Correo electrónico"}
            className={"login-input"}
            value={email}
            
            type={"email"}
            onChange={(text) => setEmail(text)}
            validateMethod={validateEmail}
            error={setErrorForgot}
        />
    {/* Hidden marker to indicate source */}
    <input type="hidden" name="origen" value={origen} />
        

        <button className={"login-button"}
                onClick={submit}>Reestablecer Mi Clave
        </button>
        {errorForgot && (<span className='login-form-error-message'>{errorMessage}</span>)}
        {hasCompleted && (<span className='login-form-error-message'>{message}</span>)}
    </div>);
}